/* ============================================================
   FleetPro Retail -- custom product gallery (Phase 3, desktop)
   Attaches to the NATIVE Athens <media-gallery> on the PDP. Adds, on
   DESKTOP only (>=990px, hover-capable): in-place hover zoom, instant
   preloaded switching with crossfade, a branded zoomable/pannable
   lightbox (click image -> open). Mobile is left 100% native (Flickity
   swipe + native modal tap-to-zoom) -- this script no-ops there.
   Native DOM/data (variant images, video, thumbnails) is untouched.
   ============================================================ */
(function () {
  var DESK = function () {
    return window.matchMedia("(min-width:990px)").matches &&
           window.matchMedia("(hover:hover)").matches;
  };
  // bump a Shopify image URL to ~2048 wide for crisp zoom (handles _NNNx. and width=NNN)
  function hi(src) {
    if (!src) return src;
    return src.replace(/_(\d+)x\./, "_2048x.").replace(/([?&]width=)\d+/, "$1" + "2048");
  }

  var LB = null; // single shared lightbox

  function buildLightbox() {
    if (LB) return LB;
    var el = document.createElement("div");
    el.className = "fpg-lb";
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-label", "Product image viewer");
    el.innerHTML =
      '<span class="fpg-lb__count"></span>' +
      '<button class="fpg-lb__close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button class="fpg-lb__nav fpg-lb__prev" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg></button>' +
      '<div class="fpg-lb__stage"><img class="fpg-lb__img" alt=""></div>' +
      '<button class="fpg-lb__nav fpg-lb__next" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>' +
      '<div class="fpg-lb__strip"></div>';
    document.body.appendChild(el);
    LB = {
      el: el,
      img: el.querySelector(".fpg-lb__img"),
      stage: el.querySelector(".fpg-lb__stage"),
      count: el.querySelector(".fpg-lb__count"),
      strip: el.querySelector(".fpg-lb__strip"),
      prev: el.querySelector(".fpg-lb__prev"),
      next: el.querySelector(".fpg-lb__next"),
      close: el.querySelector(".fpg-lb__close")
    };
    return LB;
  }

  function init(gallery) {
    if (gallery.__fpg) return;
    gallery.__fpg = true;
    var mainWrap = gallery.querySelector(".product-media-main-wrapper");
    if (!mainWrap) return;
    gallery.classList.add("fpg");

    function mains() { return [].slice.call(gallery.querySelectorAll(".product-media-main")); }
    function activeIndex() {
      var list = mains();
      var a = gallery.querySelector(".product-media-main.is-active");
      return Math.max(0, list.indexOf(a));
    }
    function imgAt(i) { var m = mains()[i]; return m ? m.querySelector("img") : null; }
    function srcAt(i) { var im = imgAt(i); return im ? hi(im.currentSrc || im.src) : ""; }

    /* ---- preload (instant switch) + idle preload hi-res ---- */
    mains().forEach(function (m) {
      var im = m.querySelector("img");
      if (im && (im.currentSrc || im.src)) { var p = new Image(); p.src = im.currentSrc || im.src; }
    });
    (window.requestIdleCallback || function (f) { setTimeout(f, 700); })(function () {
      mains().forEach(function (m) {
        var im = m.querySelector("img");
        if (im) { var p = new Image(); p.src = hi(im.currentSrc || im.src); }
      });
    });

    /* ---- in-place hover zoom (desktop) ---- */
    var zl = document.createElement("div");
    zl.className = "fpg-zoom";
    mainWrap.appendChild(zl);
    var Z = 2.3, PAD = 14;
    mainWrap.addEventListener("mousemove", function (e) {
      if (!DESK()) { zl.style.opacity = 0; return; }
      var im = imgAt(activeIndex());
      if (!im) { zl.style.opacity = 0; return; }
      var r = mainWrap.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (x < PAD || y < PAD || x > r.width - PAD || y > r.height - PAD) { zl.style.opacity = 0; return; }
      var cw = r.width - PAD * 2, ch = r.height - PAD * 2;
      zl.style.backgroundImage = "url('" + hi(im.currentSrc || im.src) + "')";
      zl.style.backgroundSize = (cw * Z) + "px " + (ch * Z) + "px";
      var fx = (x - PAD) / cw, fy = (y - PAD) / ch;
      zl.style.backgroundPosition = (-(fx * cw * (Z - 1))) + "px " + (-(fy * ch * (Z - 1))) + "px";
      zl.style.opacity = 1;
    });
    mainWrap.addEventListener("mouseleave", function () { zl.style.opacity = 0; });

    /* ---- lightbox ---- */
    var lb = buildLightbox();
    var idx = 0, scale = 1, tx = 0, ty = 0, reduce = matchMedia("(prefers-reduced-motion:reduce)").matches;

    function applyT() { lb.img.style.transform = "scale(" + scale + ") translate(" + tx + "px," + ty + "px)"; lb.img.classList.toggle("fpg-zoomed", scale > 1); }
    function resetZoom() { scale = 1; tx = 0; ty = 0; lb.img.style.transition = ""; lb.img.style.transform = ""; lb.img.classList.remove("fpg-zoomed"); }
    function clampPan() {
      var ow = (lb.img.clientWidth * (scale - 1)) / 2 / scale, oh = (lb.img.clientHeight * (scale - 1)) / 2 / scale;
      tx = Math.max(-ow, Math.min(ow, tx)); ty = Math.max(-oh, Math.min(oh, ty));
    }
    function count() { lb.count.textContent = (idx + 1) + " / " + mains().length; }
    function markStrip() {
      [].forEach.call(lb.strip.children, function (b, i) { b.classList.toggle("active", i === idx); });
      var act = lb.strip.children[idx]; if (act) act.scrollIntoView({ inline: "center", block: "nearest", behavior: reduce ? "auto" : "smooth" });
    }
    function buildStrip() {
      lb.strip.innerHTML = "";
      mains().forEach(function (m, i) {
        var t = m.querySelector("img");
        var b = document.createElement("button");
        b.className = "fpg-lb__t" + (i === idx ? " active" : "");
        b.setAttribute("aria-label", "Image " + (i + 1));
        var im = document.createElement("img"); im.src = t ? (t.currentSrc || t.src) : ""; im.alt = "";
        b.appendChild(im);
        b.addEventListener("click", function () { go(i); });
        lb.strip.appendChild(b);
      });
    }
    function syncMain(i) {
      var thumb = gallery.querySelectorAll(".product-media-thumbnail")[i];
      var btn = thumb && thumb.querySelector("button");
      if (btn) btn.click();
    }
    function go(i) {
      var n = mains().length; idx = (i + n) % n;
      lb.img.src = srcAt(idx); resetZoom(); count(); markStrip(); syncMain(idx);
    }
    function open() {
      idx = activeIndex(); lb.img.src = srcAt(idx); resetZoom(); count(); buildStrip();
      lb.el.classList.add("open");
      requestAnimationFrame(function () { requestAnimationFrame(function () { lb.el.classList.add("show"); }); });
      document.body.style.overflow = "hidden";
    }
    function closeLB() { lb.el.classList.remove("show"); document.body.style.overflow = ""; setTimeout(function () { lb.el.classList.remove("open"); }, reduce ? 0 : 220); }

    // intercept main-image clicks on desktop -> my lightbox (thumbnails NOT affected)
    gallery.addEventListener("click", function (e) {
      var inMain = e.target.closest && e.target.closest(".product-media-main");
      if (!inMain || !DESK()) return; // mobile keeps native modal
      e.preventDefault(); e.stopImmediatePropagation();
      open();
    }, true);

    // lightbox controls (bind once)
    if (!lb.el.__wired) {
      lb.el.__wired = true;
      lb.close.addEventListener("click", closeLB);
      lb.prev.addEventListener("click", function () { go(idx - 1); });
      lb.next.addEventListener("click", function () { go(idx + 1); });
      lb.el.addEventListener("click", function (e) { if (e.target === lb.el || e.target === lb.stage) closeLB(); });
      document.addEventListener("keydown", function (e) {
        if (!lb.el.classList.contains("open")) return;
        if (e.key === "Escape") closeLB();
        else if (e.key === "ArrowLeft") go(idx - 1);
        else if (e.key === "ArrowRight") go(idx + 1);
      });
      lb.img.addEventListener("click", function (e) {
        e.stopPropagation();
        if (moved) { moved = false; return; } // a pan-drag, not a click -> keep current zoom
        if (scale > 1) { resetZoom(); return; }
        scale = 2.4;
        var r = lb.img.getBoundingClientRect();
        var cx = (e.clientX - (r.left + r.width / 2)) / scale, cy = (e.clientY - (r.top + r.height / 2)) / scale;
        tx = -cx; ty = -cy; clampPan(); applyT();
      });
      lb.stage.addEventListener("wheel", function (e) {
        if (!lb.el.classList.contains("open")) return;
        e.preventDefault();
        var prev = scale;
        scale = Math.min(4, Math.max(1, scale - (e.deltaY > 0 ? 0.25 : -0.25)));
        if (scale === 1) { tx = 0; ty = 0; } else { var f = scale / prev; tx *= f; ty *= f; clampPan(); }
        lb.img.style.transition = "transform .08s linear"; applyT();
      }, { passive: false });
      var drag = false, sx = 0, sy = 0, stx = 0, sty = 0, moved = false;
      lb.img.addEventListener("pointerdown", function (e) { moved = false; if (scale <= 1) return; drag = true; lb.img.classList.add("fpg-grab"); sx = e.clientX; sy = e.clientY; stx = tx; sty = ty; lb.img.setPointerCapture(e.pointerId); });
      lb.img.addEventListener("pointermove", function (e) { if (!drag) return; if (Math.abs(e.clientX - sx) + Math.abs(e.clientY - sy) > 3) moved = true; tx = stx + (e.clientX - sx) / scale; ty = sty + (e.clientY - sy) / scale; clampPan(); applyT(); });
      function end() { drag = false; lb.img.classList.remove("fpg-grab"); }
      lb.img.addEventListener("pointerup", end); lb.img.addEventListener("pointercancel", end);
    }
  }

  function boot() {
    document.querySelectorAll("media-gallery.product-media-gallery").forEach(init);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  // theme editor section reloads
  document.addEventListener("shopify:section:load", boot);
})();
